
// 服务器获取配置
const configuration = {
    namespaced: true,
    state: {
        configuration: {
            // 登录跳转
            ssoBase: '',
            // 主站
            webSiteUrl: '',
            // 当前网站
            labUrl:'',
            // 统计API
            tongjiUrl: '',
            // 工作台
            workUrl: '',
            fp: null
        },
    },
    getters: {
        configuration: state => state.configuration,
        ssoBase: state => state.configuration.ssoBase,
        webSiteUrl: state => state.configuration.webSiteUrl,
        labUrl: state => state.configuration.labUrl,
        tongjiUrl: state => state.configuration.tongjiUrl,
        workUrl: state => state.configuration.workUrl,
        fp: state => state.configuration.fp
    },
    actions: {
        setConfiguration: async ({ commit }) => {
            const {configuration} = (window as any).INIT_DATA;

            commit('setConfiguration', {
                ssoBase: configuration.app.sso_base,
                webSiteUrl: configuration.webSiteurl,
                labUrl: configuration.labUrl,
                tongjiUrl: configuration.tongjiUrl,
                workUrl: configuration.workUrl,
                fp: configuration.fp
            });
        },
    },
    mutations: {
        setConfiguration(state, payload) {
            state.configuration = payload;
        },
    },
};

export default configuration;
